import * as event from './event';
import * as user from './user';

// eslint-disable-next-line import/no-anonymous-default-export
export default { user, event };
